import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/',
    validateStatus: function (status) {
        return status >= 200 && status <= 302
    }
});

const pinata = axios.create({
    baseURL: 'https://api.pinata.cloud/',
    validateStatus: function (status) {
        return status >= 200 && status <= 302
    },
});

export const getNFTs = async () => server.get("/nfts");
export const getNFT = async (tokenId: string) => server.get(`/nfts/${tokenId}`);
export const getUserNFTBalance = async (address: string) => server.get(`/nfts/balance/${address}`);
export const getUserNFTs = async (address: string) => server.get(`/nfts/user/${address}`);

export const getListings = async () => server.get("/listings");
export const getMyListings = async (address: string) => server.get(`/listings/user/${address}`);
export const getPurchasedListings = async (address: string) => server.get(`/listings/purchased/${address}`);

export const uploadNFTMetadata = async (metadata: any) => pinata.post("/pinning/pinFileToIPFS", metadata, {
    maxBodyLength: Infinity,
    headers: {
        'accept': 'application/json',
        'Content-Type': `multipart/form-data; boundary=${metadata._boundary}`,
        'authorization': `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
    }
});
